module.exports = __webpack_public_path__ + "img/itx-file-type-ogv.b3a57953.svg";